export default {
  bbSandbox: 'buyback-sandbox.luxclusif.com',
  bbProd: 'buyback.luxclusif.com',

  stSandbox: 'selection-sandbox.luxclusif.com',
  stProd: 'selection.luxclusif.com',

  cmSandbox: 'profiles.channels.sandbox.luxclusif.com',
  cmStaging: 'profiles.channels.staging.luxclusif.com',
  cmProd: 'channels.luxclusif.com',

  cmOffersSandbox: 'offers.channels.sandbox.luxclusif.com',
  cmOffersStaging: 'offers.channels.staging.luxclusif.com',
  cmOffersProd: 'offers.channels.luxclusif.com',

  cmAllocationSandbox: 'allocation.channels.sandbox.luxclusif.com',
  cmAllocationStaging: 'allocation.channels.staging.luxclusif.com',
  cmAllocationProd: 'allocation.channels.luxclusif.com',

  cmCPMSandbox: 'cpm.channels.sandbox.luxclusif.com',
  cmCPMStaging: 'cpm.channels.staging.luxclusif.com',
  cmCPMProd: 'cpm.channels.luxclusif.com',

  ibSandbox: 'sandbox-inbound.luxclusif.com',
  ibProd: 'inbound.luxclusif.com',

  ivSandbox: 'sandbox-inventory.luxclusif.com',
  ivProd: 'inventory.luxclusif.com',

  prSandbox: 'sandbox-products.luxclusif.com',
  prProd: 'products.luxclusif.com',

  opSandbox: 'sandbox-operations.luxclusif.com',
  opProd: 'operations.luxclusif.com',
};
